// common modules
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule,HTTP_INTERCEPTORS  } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { DatePipe } from '@angular/common'

// material modules
import { MaterialModule } from './app-material.module';

// keep alive library
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

// custom component
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SearchboxComponent } from './searchbox/searchbox.component';
import { DetailComponent } from './detail/detail.component';
import { DatatableComponent } from './datatable/datatable.component';
import { UserAreaComponent } from './user-area/user-area.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { StandardProfessionaliComponent } from './pages/standard-professionali/standard-professionali.component';
import { CertificazioneCompetenzeComponent } from './pages/certificazione-competenze/certificazione-competenze.component';
import { NormaRiferimentoComponent } from './pages/norma-riferimento/norma-riferimento.component';
import { DecretiApprovazioneComponent } from './pages/decreti-approvazione/decreti-approvazione.component';
import { FigureComponent } from './pages/figure/figure.component';
import { PercorsiComponent } from './pages/percorsi/percorsi.component';
import { AttoriComponent } from './pages/attori/attori.component';
import { GlossarioComponent } from './pages/glossario/glossario.component';
import { FaqComponent } from './pages/faq/faq.component';
import {SideMenuItemComponent} from "./components/side-menu/side-menu-item/side-menu-item.component";
import {ExternalSideMenuComponent} from "./components/side-menu/external-side-menu/external-side-menu.component";
import {InternalSideMenuComponent} from "./components/side-menu/internal-side-menu/internal-side-menu.component";
import { ListaAssociazioniDialog } from "./dialog/lista-associazioni-dialog/lista-associazioni-dialog.component";

// interceptors
import { SpinnerInterceptor } from './interceptors/spinner.interceptor';
import { ErrorCatchingInterceptor } from './interceptors/error-catching.interceptor';

// pipes
import { SearchtextPipe } from './pipes/searchtext.pipe';
import { ContainerComponent } from './container/container.component';
import { RicercaProfiliCompetenzeComponent } from './pages/ricerca-profili-competenze/ricerca-profili-competenze.component';
import {TileComponent} from "./components/tile/tile.component";
import {
  AtlanteProfiliCompetenzeComponent
} from "./components/atlante-profili-competenze/atlante-profili-competenze.component";
import {AtlanteCompetenzeComponent} from "./components/atlante-competenze/atlante-competenze.component";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {CustomMatPaginatorIntl} from "./custom-mat-paginator-intl/custom-mat-paginator-intl.component";
import {
  ReplaceAndArchiveProfileDialog
} from "./dialog/replace-and-archive-profile-dialog/replace-and-archive-profile-dialog.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {DetailProfiloDialog} from "./pages/ricerca-profili-competenze/detail-profilo/detail-profilo.component";
import {DetailCompetenzaDialog} from "./pages/ricerca-profili-competenze/detail-competenze/detail-competenza.component";
import {
  DetailAbilitaConoscenzeDialog
} from "./pages/ricerca-profili-competenze/detail-abilita-conoscenze/detail-abilita-conoscenze.component";
import {MatButtonToggleModule} from "@angular/material/button-toggle";


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LandingComponent,
    WelcomeComponent,
    SearchboxComponent,
    DetailComponent,
    DatatableComponent,
    UserAreaComponent,
    SearchtextPipe,
    BreadcrumbsComponent,
    HomePageComponent,
    StandardProfessionaliComponent,
    CertificazioneCompetenzeComponent,
    NormaRiferimentoComponent,
    DecretiApprovazioneComponent,
    FigureComponent,
    PercorsiComponent,
    AttoriComponent,
    GlossarioComponent,
    FaqComponent,
    ContainerComponent,
    RicercaProfiliCompetenzeComponent,
    AtlanteProfiliCompetenzeComponent,
    AtlanteCompetenzeComponent,
    ExternalSideMenuComponent,
    InternalSideMenuComponent,
    SideMenuItemComponent,
    ListaAssociazioniDialog,
    ReplaceAndArchiveProfileDialog,
    DetailProfiloDialog,
    DetailCompetenzaDialog,
    DetailAbilitaConoscenzeDialog
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatNativeDateModule,
        MaterialModule,
        HttpClientModule,
        NgIdleKeepaliveModule.forRoot(),
        TileComponent,
        MatSlideToggleModule,
        MatButtonToggleModule
    ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorCatchingInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }
    // { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
